import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { ElementRef,Component, EventEmitter, Input, Output } from '@angular/core';
import { faXmark, faX, faArrowDown, faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { Category } from '../../models/Category';
import { InfoCenterFile } from '../../models/InfoCenterFile';
import { User } from '../../models/User';
import { HttpService } from '../../services/HttpService';
import { HttpResponse } from '@angular/common/http';
import { Distributor } from '../../models/Distributor';
import { GlobalService } from '../../services/global';

export interface IHeaders {
  type: string;
  file: {
    FullPath: string;
    FileName: string;
    CreateDate: Date;
    UpdateDate: Date;
    Active: boolean;
    FileData: File;
    FileType: string;
    Description: string;
    EnabledFor: string;
    Category: number;
    Type: string;
    Index: number;
  },
  category: {
    CategoryID: number;
    Name: string;
    CategoryType: string;
    SortOrder: number;
    ParentID: number;
    Files: InfoCenterFile[];
  }
}

@Component({
  selector: 'app-category-accordian',
  standalone: false,  
  templateUrl: './category-accordian.component.html',
  styleUrl: './category-accordian.component.css'
})

export class CategoryAccordianComponent {
  faXmark = faXmark;
  faX = faX;
  faArrowDown = faArrowDown;
  faPenToSquare = faPenToSquare;
  @Input() CurUser: User;
  @Input() cat: Category;
  @Input() FileList: InfoCenterFile[];
  @Output() EditFileClick = new EventEmitter<InfoCenterFile>();
  @Output() DropFileEvent = new EventEmitter<InfoCenterFile>();
  @Output() RemoveFileClick = new EventEmitter<InfoCenterFile>();  
  public constructor(private http: HttpService, private elementRef: ElementRef, private global: GlobalService) {
    
  }

  CatOrFileDropped(event: CdkDragDrop<IHeaders[]>, catID: number) {

    //var catID = parseInt(catIDstring);
    if (event.currentIndex == event.previousIndex)
      return;

    var isMoveAhead = (event.currentIndex - event.previousIndex) < 0;
    if (event.item.data.type == 'file') {
      var currentFile = this.cat.Files.filter(x => x.Index == event.previousIndex)[0];
      var catFileList = this.cat.Files;

      if (isMoveAhead) {
        for (var i = 0; i < catFileList.length; i++) {
          if (catFileList[i].Index < event.previousIndex && catFileList[i].Index >= event.currentIndex) {
            catFileList[i].Index += 1;
          }
        }
      } else {
        for (var i = 0; i < catFileList.length; i++) {
          if (catFileList[i].Index <= event.currentIndex && catFileList[i].Index > event.previousIndex) {
            catFileList[i].Index -= 1;
          }
        }
      }

      currentFile.Index = event.currentIndex;

      catFileList.sort((a: any, b: any) => {
        if (a.Index < b.Index) {
          return -1;
        } else if (a.Index > b.Index) {
          return 1;
        } else {
          return 0;
        }
      });


      catFileList.forEach(x => {
        this.http.UpdateFileIndex(x);
      });
    } else {
      var currentCat = this.cat.Children.filter(x => x.SortOrder == event.previousIndex)[0];
      var catCategoryList = this.cat.Children;

      if (isMoveAhead) {
        for (var i = 0; i < catCategoryList.length; i++) {
          if (catCategoryList[i].SortOrder < event.previousIndex && catCategoryList[i].SortOrder >= event.currentIndex) {
            catCategoryList[i].SortOrder += 1;
          }
        }
      } else {
        for (var i = 0; i < catCategoryList.length; i++) {
          if (catCategoryList[i].SortOrder <= event.currentIndex && catCategoryList[i].SortOrder > event.previousIndex) {
            catCategoryList[i].SortOrder -= 1;
          }
        }
      }

      currentCat.SortOrder = event.currentIndex;

      catCategoryList.sort((a: any, b: any) => {
        if (a.SortOrder < b.SortOrder) {
          return -1;
        } else if (a.SortOrder > b.SortOrder) {
          return 1;
        } else {
          return 0;
        }
      });

      catCategoryList.forEach(x => {
        this.http.UpdateCategorySortOrder(x);
      });

    }
  }

  public EditFile(file: InfoCenterFile) {
    //this.EditFileClick.emit(file);
    const event: CustomEvent = new CustomEvent('FileEditEvent', {
    bubbles: true,
      detail: file
    });
    this.elementRef.nativeElement.dispatchEvent(event);

  }

  public RemoveFile(file: InfoCenterFile) {
    //this.RemoveFileClick.emit(file);
    const event: CustomEvent = new CustomEvent('FileDeleteEvent', {
      bubbles: true,
      detail: file
    });
    this.elementRef.nativeElement.dispatchEvent(event);
  }

  DownloadFile(file: InfoCenterFile) {
    this.global.getCurrentDist().then(dist => {
      this.http.PostUserActivity(this.CurUser.UserId.toString(), "Info Center", "Download File", file.FileName, this.CurUser.IsTolomaticUser ? dist.CompanyId : this.CurUser.DistributorId);
    });
    
    if (file.Type == 'upload') {
      this.http.DownloadInfoCenterFile(this.CurUser.UserId.toString(), file.InfoCenterFileID).subscribe(({ body, headers }: HttpResponse<any>) => {
        debugger;
        var contentType = headers.get('content-type');
        const blob = new Blob([body], { type: contentType });
        var fileURL = URL.createObjectURL(blob);


        var a = document.createElement("a");
        a.href = fileURL;
        a.download = file.FileName;
        a.click();
      });
    }
    else {
      var a = document.createElement("a");
      a.href = file.FullPath;
      a.download = file.FileName;
      a.target = "_blank";
      a.click();
    }
  }
}
